// extracted by mini-css-extract-plugin
export default {"wrap":"JF-z","subtitle":"KF-z","contentWrap":"LF-z","imgWrap":"MF-z","heading":"NF-z","copy":"OF-z"};